<template>
  <div class="home" v-loading="loading">
    <!-- 过期预警横幅：平时隐藏，仅快过期/已过期时展示 -->
    <div class="alert-banner" v-if="!loading && (isExpiringSoon || isExpired)">
      <!-- 场景1：快过期（橙色预警） -->
      <el-alert
        v-if="isExpiringSoon"
        type="warning"
        show-icon
        :closable="false">
        <template slot="title">
          您的基础套餐将于 <b>{{ daysRemaining }}</b> 天后到期 ({{ endTime }})，
          请及时续费以免影响技师排班。
          <el-button type="text" size="small" @click="goToPay">立即续费</el-button>
        </template>
      </el-alert>

      <!-- 场景2：已过期（红色报警） -->
      <el-alert
        v-if="isExpired"
        type="error"
        effect="dark"
        show-icon
        :closable="false">
        您的服务已于 {{ endTime }} 到期，C端预约功能已暂停。
        <el-button size="mini" type="danger" @click="goToPay">立即恢复服务</el-button>
      </el-alert>
    </div>

    <div class="home-top">
      <div class="operation-wrap">
        <el-row>
          <el-col :span="6" class="d-c-c">
            <div class="grid-content blue">
              <div class="info">
                <h3>{{top_data.order_total}}</h3>
                <p>订单总量</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="d-c-c">
            <div class="grid-content purple">
              <div class="info">
                <h3 style="font-size: 32px;">{{top_data.month_money}}</h3>
                <p>本月收入(元)</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="d-c-c">
            <div class="grid-content yellow ">
              <div class="info">
                <h3 style="font-size: 32px;">{{Math.floor(top_data.total_money)}}</h3>
                <p>销售总额(元)</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6" class="d-c-c">
            <div class="grid-content orderred">
              <div class="info">
                <h3>{{top_data.fav_count}}</h3>
                <p>店铺收藏总数</p>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="right-side">
        <!-- 权益常驻面板：放在右侧最上方 -->
        <el-card class="subscription-card" shadow="never">
          <div slot="header" class="subscription-card__header">
            <span>当前套餐</span>
            <el-tag size="mini" :type="subscriptionTagType">{{ subscriptionTagText }}</el-tag>
          </div>

          <div class="subscription-card__row">
            <span class="muted">到期时间</span>
            <div class="right">
              <span class="bold">{{ endTime || '-' }}</span>
              <el-button type="text" size="small" @click="goToPay">续费</el-button>
            </div>
          </div>

          <div class="subscription-card__label">
            <span class="muted f12">技师名额 ({{ usedStaff }}/{{ totalStaff }})</span>
          </div>
          <el-progress
            :text-inside="true"
            :stroke-width="18"
            :percentage="usagePercentage"
            :status="usageStatus">
          </el-progress>

          <div class="subscription-card__actions">
            <el-button type="primary" size="mini" round @click="openBuyStaffModal">购买名额</el-button>
            <el-button type="warning" plain size="mini" round @click="goToPay">套餐续费</el-button>
          </div>
        </el-card>

        <div class="score">
          <div class="score_tit">店铺评分</div>
          <ul class="score_list">
            <li class="score_item">描述相符：{{top_data.describe_score}}分</li>
            <li class="score_item">服务态度：{{top_data.server_score}}分</li>
            <li class="score_item">配送服务：{{top_data.express_score}}分</li>
          </ul>
        </div>
      </div>
    </div>
    <div class="home-index">
      <!--main-index-->
      <div class="main-index">
        <div class="common-form mt16" style="font-size: 18px;">
          今日概况
        </div>
        <el-row class="border-b">
          <el-col :span="6">
            <div class="grid-content">
              <div class="info">
                <p class="des">销售额(元)</p>
                <h3>{{order_data.order_total_price.tday}}</h3>
                <p class="yesterday">昨日：{{order_data.order_total_price.ytd}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <div class="info">
                <p class="des">支付订单数</p>
                <h3>{{order_data.order_total.tday}}</h3>
                <p class="yesterday">昨日：{{order_data.order_total.ytd}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <div class="info">
                <p class="des">线上预付收入(元)</p>
                <h3>{{order_data.online_price.tday}}</h3>
                <p class="yesterday">昨日：{{order_data.online_price.ytd}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="grid-content">
              <div class="info">
                <p class="des">线下到店收入(元)</p>
                <h3>{{order_data.offline_price.tday}}</h3>
                <p class="yesterday">昨日：{{order_data.offline_price.ytd}}</p>
              </div>
            </div>
          </el-col>
        </el-row>
        <div>
          <!--交易统计-->
          <Transaction v-if="!loading"></Transaction>
        </div>
      </div>

      <!--待办事项-->
      <div class="matters-wrap">
        <div class="p-0-30">
          <div class="common-form mt16" style="font-size: 18px;">
            待办事项<span class="ml10 f14 gray" style="font-weight: normal;">请尽快处理，以免影响营业</span>
          </div>
          <el-row class="matters_box">
            <el-col :span="24">
              <div class="matters">
                <div class="box">
                  <div class="title">售后</div>
                  <ul class="matters_item">
                    <li><span class="fb">{{wait_data.order.refund}}</span>待处理售后</li>
                  </ul>
                </div>
              </div>
            </el-col>
          </el-row>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import IndexApi from '@/api/index.js';
  import Transaction from '@/views/home/part/Transaction.vue';
  export default {
    components: {
      Transaction,
    },
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*头部数据*/
        top_data: [],
        /*订阅/套餐信息（用于过期预警横幅）*/
        subscription: {
          detail: null,
          active_technician_count: 0,
        },
        order_data: {
          order_total_price: {},
          order_total: {},
          online_price: {},
          offline_price: {},
        },
        /*待办事项*/
        wait_data: {
          order: {},
        },
      };
    },
    computed: {
      subscriptionDetail() {
        return this.subscription && this.subscription.detail ? this.subscription.detail : null;
      },
      endTime() {
        return this.subscriptionDetail && this.subscriptionDetail.end_time ? this.subscriptionDetail.end_time : '';
      },
      status() {
        return this.subscriptionDetail && typeof this.subscriptionDetail.status !== 'undefined'
          ? Number(this.subscriptionDetail.status)
          : null;
      },
      daysRemaining() {
        const end = this.parseDateTime(this.endTime);
        if (!end) return null;
        const diffMs = end.getTime() - Date.now();
        // 向上取整：比如剩余 0.2 天也算 1 天，符合用户感知
        return Math.ceil(diffMs / (24 * 60 * 60 * 1000));
      },
      isExpiringSoon() {
        // 橙色预警：status == 10 且 剩余天数 <= 7（且未过期）
        return this.status === 10
          && typeof this.daysRemaining === 'number'
          && this.daysRemaining >= 0
          && this.daysRemaining <= 7;
      },
      isExpired() {
        // 红色报警：status == 30（已过期）
        return this.status === 30;
      },
      totalStaff() {
        const v = this.subscriptionDetail && this.subscriptionDetail.total_allowed_staff;
        const n = Number(v);
        return isNaN(n) ? 0 : n;
      },
      usedStaff() {
        const v = this.subscription && this.subscription.active_technician_count;
        const n = Number(v);
        return isNaN(n) ? 0 : n;
      },
      usagePercentage() {
        if (!this.totalStaff || this.totalStaff <= 0) return 0;
        const pct = Math.round((this.usedStaff / this.totalStaff) * 100);
        return Math.max(0, Math.min(100, pct));
      },
      usageStatus() {
        // ElementUI Progress 的 status：success / exception / warning
        // 满员或超额：warning（更醒目）
        if (this.totalStaff > 0 && this.usedStaff >= this.totalStaff) return 'warning';
        return 'success';
      },
      subscriptionTagText() {
        if (this.isExpired) return '已到期';
        if (this.isExpiringSoon) return '快到期';
        if (this.status === 10) return '生效中';
        return '未知';
      },
      subscriptionTagType() {
        if (this.isExpired) return 'danger';
        if (this.isExpiringSoon) return 'warning';
        return 'success';
      },
    },
    created() {
      /*获取数据*/
      this.getData();
    },
    methods: {
      /*解析 YYYY-MM-DD HH:mm:ss（兼容各浏览器/环境）*/
      parseDateTime(str) {
        if (!str) return null;
        // 将 "2026-02-17 23:02:36" 转成 "2026-02-17T23:02:36"
        const normalized = String(str).trim().replace(' ', 'T');
        const d = new Date(normalized);
        if (!isNaN(d.getTime())) return d;
        // 兜底：把 '-' 替换为 '/'，兼容部分环境
        const fallback = new Date(String(str).trim().replace(/-/g, '/'));
        return isNaN(fallback.getTime()) ? null : fallback;
      },
      /*去续费/支付页面（跳转到套餐管理页面，自动切换到续费Tab）*/
      goToPay() {
        this.$router.push({
          path: '/setting/subscription/index',
          query: { tab: 'renew' }
        });
      },
      /*打开购买名额页面（跳转到套餐管理页面，自动切换到购买名额Tab）*/
      openBuyStaffModal() {
        this.$router.push({
          path: '/setting/subscription/index',
          query: { tab: 'addStaff' }
        });
      },
      /*获取数据*/
      getData() {
        let self = this;
        IndexApi.getCount(true).then(data => {
          self.loading = false;
          self.top_data = data.data.data.top_data;
          self.subscription = data.data.data.subscription || self.subscription;
          self.order_data = data.data.data.order_data;
          self.wait_data = data.data.data.wait_data;
        }).catch(error => {

        });
      },
    }
  };
</script>

<style lang="scss" scoped>
  .operation-wrap {
    width: 100%;
    height: 164px;
    border-radius: 8px;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    background-size: 100% 100%;
    color: #FFFFFF;
  }

  .alert-banner {
    width: 100%;
    margin-bottom: 20px;
  }

  /* 顶部区域：右侧面板脱离文档流，避免把整行撑高造成左侧下方大空白 */
  .home-top {
    position: relative;
    padding-right: 255px; /* 240(right-side) + 15 间距 */
  }

  .home-top .operation-wrap {
    width: 100%;
  }

  .right-side {
    width: 240px;
    position: absolute;
    top: 0;
    right: 0;
    z-index: 99;
  }

  .subscription-card {
    width: 240px;
    border: 1px solid #f1f1f1;
    border-radius: 8px;
    margin-bottom: 15px;
  }

  .subscription-card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .subscription-card__row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .subscription-card__row .right {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .subscription-card__label {
    margin-bottom: 6px;
  }

  .subscription-card__actions {
    margin-top: 12px;
    display: flex;
    justify-content: center;
    gap: 10px;
  }

  .muted {
    color: #999999;
  }

  .bold {
    font-weight: bold;
    color: #333333;
  }

  .f12 {
    font-size: 12px;
  }

  .home .operation-wrap .grid-content {
    width: 90%;
    height: 150px;
    justify-content: flex-start;
    align-items: center;
    padding-left: 23px;
  }

  .operation-wrap .grid-content h3 {
    font-size: 36px;
    line-height: 40px;
  }

  .operation-wrap .grid-content .info h3 {
    font-size: 40px;
    line-height: 40px;
    color: #FFFFFF;
    text-align: left;
    margin-bottom: 20px;
  }

  .home .operation-wrap .grid-content .info {
    margin-left: 10px;
    text-align: left;
    font-size: 14px;
    color: #FFFFFF;
  }

  .operation-wrap .grid-content .svg-icon {
    color: #FFFFFF;
  }

  .home-index {
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: horizontal;
    -webkit-box-direction: normal;
    -ms-flex-direction: row;
    flex-direction: row;
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    justify-content: space-between;
    min-width: 1000px;
    overflow-x: auto;
  }

  .operation-wrap .grid-content.blue {
    background: url(../../assets/img/total_order.png) no-repeat;
    background-size: 100% 100%;
  }

  .operation-wrap .grid-content.yellow {
    background: url(../../assets/img/total_user.png) no-repeat;
    background-size: 100% 100%;
  }

  .operation-wrap .grid-content.purple {
    background: url(../../assets/img/total_volume.png) no-repeat;
    background-size: 100% 100%;
  }

  .operation-wrap .grid-content.orderred {
    background: url(../../assets/img/total_shop.png) no-repeat;
    background-size: 100% 100%;
  }

  .operation-wrap .grid-content .info h3 {
    font-size: 40px;
    line-height: 40px;
    color: #FFFFFF;
    text-align: left;
    margin-bottom: 20px;
  }

  .operation-wrap .grid-content .info {
    margin-left: 10px;
    text-align: center;
    font-size: 14px;
    color: #FFFFFF;
  }

  .operation-wrap .grid-content .svg-icon {
    color: rgba(255, 255, 255, .3);
    font-size: 300%;
  }

  .main-index {
    flex: 1;
  }

  .main-index .grid-content,
  .operation-wrap .grid-content {

    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: row;
    -ms-flex-direction: row;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .main-index .grid-content {
    height: 120px;
  }

  .main-index .grid-content .pic {
    margin-right: 10px;
  }

  .main-index .grid-content h3 {
    font-size: 20px;
    font-weight: normal;
  }

  .main-index .grid-content .yesterday {
    color: #ccc;
  }

  .main-index .grid-content .svg-icon {
    color: #3a8ee6;
  }

  .matters-wrap {
    padding-bottom: 15px;
    width: 40%;
  }

  .matters .box {
    width: 100%;
  }

  .matters-wrap .matters {
    display: -ms-flexbox;
    display: flex;
    -webkit-box-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    // height: 120px;
    margin-bottom: 30px;
  }

  .matters-wrap .matters .title {
    font-size: 16px;
    color: #333333;
    display: inline-block;
    height: 20px;
    line-height: 0;
    padding: 11px;
    text-align: center;
    margin-bottom: 20px;
  }

  .matters-wrap .matters ul {
    color: #999999;
  }

  .matters-wrap .matters ul span {
    padding-right: 6px;
    color: #3a8ee6;
  }

  .score {
    width: 240px;
    // height: 164px;
    box-shadow: inherit;
    border: 1px solid #f1f1f1;
    border-radius: 8px;
    background-color: #fff;

    .score_tit {
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 1);
      position: relative;
      height: 42px;
      line-height: 42px;
      padding: 0 15px;
      border-bottom: 1px solid #f6f6f6;
      color: #333;
      border-radius: 2px 2px 0 0;
      font-size: 14px;
    }

    .border-b {
      display: flex;
      flex-direction: column;
    }

    .score_list {
      position: relative;
      padding: 15px 15px;
      line-height: 28px;

      .score_item {
        color: #333;
        text-decoration: none;
      }

    }
  }

  .grid-content .info h3 {
    font-weight: bold;
    color: #5d75e3;
    text-align: center;
  }

  .grid-content .info .des {
    font-size: 16px;
    margin-bottom: 6px;
  }

  .grid-content .info .yesterday {
    font-size: 13px;
    text-align: center;
  }

  .matters_box {
    width: 57%;
    border-top: 1px solid #d9d9d9;
    padding-top: 20px;
  }

  .matters-wrap .matters_item li .fb {
    font-size: 16px;
    color: #5d75e3;
  }

  .matters_item li {
    width: 72px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-right: 16px;
  }
</style>



// WEBPACK FOOTER //
// src/views/home/home.vue